import { render, staticRenderFns } from "./choose-progress-record.vue?vue&type=template&id=2241fd9a&scoped=true&"
import script from "./choose-progress-record.vue?vue&type=script&lang=js&"
export * from "./choose-progress-record.vue?vue&type=script&lang=js&"
import style0 from "./choose-progress-record.vue?vue&type=style&index=0&id=2241fd9a&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241fd9a",
  null
  
)

export default component.exports